// Import model
import { WoodCatalogItemCondition } from '../models/WoodCatalogItemCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { WoodCatalogItemIndexedFields } from '../models/WoodCatalogItemIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { WoodCatalogItemIndexedFieldsSerializer } from './WoodCatalogItemIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for WoodCatalogItemCondition - handles JSON serialization and deserialization with type validation
 */
export class WoodCatalogItemConditionSerializer {
  /**
   * Deserializes a JSON string into a WoodCatalogItemCondition instance
   */
  static deserialize(json: string): WoodCatalogItemCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a WoodCatalogItemCondition instance
   */
  static fromObject(obj: any): WoodCatalogItemCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to WoodCatalogItemCondition');
    }


    const instance: WoodCatalogItemCondition = {
      fieldName: obj['fieldName'] as WoodCatalogItemIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of WoodCatalogItemCondition instances
   */
  static deserializeArray(json: string): WoodCatalogItemCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a WoodCatalogItemCondition instance to a JSON string
   */
  static serialize(instance: WoodCatalogItemCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a WoodCatalogItemCondition instance to a plain object
   */
  static toObject(instance: WoodCatalogItemCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of WoodCatalogItemCondition instances to a JSON string
   */
  static serializeArray(instances: WoodCatalogItemCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
